export default __webpack_public_path__ + "static/media/logo_card.8fc0c4f6.png";